import useInterceptor from './useInterceptor';
export default useInterceptor;
